<template>
  <div>
    <div id="overlay" v-if="fetchingData">
      <div class="spinner"></div>
    </div>
    <h3>Open Burn Permit Application Review</h3>
    <expanded-fieldset title="Permit Verification">
      <fieldset>
        <legend>Application Information</legend>
        <div class="row w-100">
          <div class="col-6">
            <yes-no v-model="application.hasPermit"
                    label="Do you have a State Permit?"
                    message="A State Permit is required to cmoplete an Open Burn Permit"
                    disabled />
          </div>
          <div class="col-6">
            <base-file-uploader v-model="application.files.statePermit"
                                label="State Permit"
                                :file="application.existingFileDetails.statePermit" disabled />
          </div>
        </div>
        <div class="row w-100">
          <div class="col-6">
            <base-input v-model="application.permitNumber"
                    label="Application Number"
                    placeholder="Application Number"
                    disabled />
          </div>
        </div>
      </fieldset>
    </expanded-fieldset>
    <expanded-fieldset title="Applicant Information">
      <fieldset>
        <legend>Applicant Information</legend>
        <div class="row w-100">
          <div class="col">
            <base-input v-model="application.applicantFirstName"
                        label="Applicant First Name"
                        placeholder="Applicant First Name" disabled />
          </div>
          <div class="col">
            <base-input v-model="application.applicantLastName"
                        label="Applicant Last Name"
                        placeholder="Applicant Last Name" disabled />
          </div>
          <div class="col">
            <base-input v-model="application.applicantPhone"
                        label="Applicant Phone"
                        type="tel"
                        mask="(###)-###-####"
                        placeholder="(xxx)-xxx-xxxx" disabled />
          </div>
        </div>
        <div class="row w-100">
          <div class="col">
            <base-input v-model="application.applicantEmail"
                        label="Applicant Email"
                        placeholder="Applicant Email"
                        type="email" disabled />
          </div>
          <div class="col">
            <base-input v-model="application.confirmEmail"
                        label="Confirm Email"
                        placeholder="Confirm Email"
                        type="email" disabled />
          </div>
        </div>
        <div class="row w-100">
          <div class="col">
            <label> Applicant Address </label>
            <v-address v-model="application.applicantAddress"
                       labelPrefix="Applicant Address"
                       :show-unincorporated="false" disabled />
          </div>
        </div>
        <div class="row w-100">
          <div class="col">
            <base-select v-model="application.typeOfRequest"
                         :options="formFieldData.typeOfRequestOptions"
                         label="Type of Burn Request" disabled>
            </base-select>
          </div>
          <div class="col" v-if="application.typeOfRequest == 'Other'">
            <base-input v-model="application.typeOfRequestOtherDesc"
                        label="Other (Specify)"
                        placeholder="Description" disabled />
          </div>
        </div>
        <div class="row w-100">
          <div class="col-6">
            <base-file-uploader v-model="application.files.vicinitySketch"
                                label="Sketch of Immediate Vicinity"
                                :file="application.existingFileDetails.vicinitySketch" disabled/>
          </div>
          <div class="col-6">
            <base-file-uploader v-model="application.files.printedMap"
                                label="Printed Map of General Area"
                                :file="application.existingFileDetails.printedMap" disabled/>
          </div>
        </div>
        <div class="w-100" v-if="application.typeOfRequest == 'Firefighting Instruction / Research'">
          <div class="row w-100">
            <div class="col-6">
              <base-file-uploader v-model="application.files.asbestosAssessmentFile"
                                  label="Asbestos Assessment"
                                  :file="application.existingFileDetails.asbestosAssessmentFile" disable/>
            </div>
            <div class="col-6">
              <base-file-uploader v-model="application.files.demolitonPermit"
                                  label="Demolition Permit"
                                  :file="application.existingFileDetails.demolitonPermit" disabled/>
            </div>
          </div>
        </div>
      </fieldset>
    </expanded-fieldset>
    <expanded-fieldset title="Burn Information">
      <fieldset>
        <legend> Burn Information </legend>
        <div class="row w-50">
          <div class="col">
            <base-input v-model="application.siteName"
                        label="Burn Site Name"
                        placeholder="Burn Site Name" disabled />
          </div>
        </div>
        <legend> Burn Site Address </legend>
        <div class="row w-100">
          <div class="col">
            <base-input v-model="application.siteAddress"
                        label="Burn Site Address"
                        placeholder="Burn Site Address" disabled />
          </div>
        </div>
        <div class="row w-100">
          <div class="col">
            <base-input v-model="application.siteAddress2"
                        label="Burn Site Address 2"
                        placeholder="Burn Site Address 2" disabled />
          </div>
        </div>
        <div class="row w-100">
          <div class="col">
            <base-input v-model="application.siteCity"
                        label="Burn Site City"
                        placeholder="Burn Site City" disabled />
          </div>
          <div class="col">
            <base-select v-model="application.siteState"
                         label="Burn Site State"
                         :options="formFieldData.states"
                         placeholder="Burn Site State" disabled />
          </div>
          <div class="col">
            <base-input v-model="application.siteZip"
                        label="Burn Site Zip Code"
                        placeholder="Burn Site Zip Code" disabled />
          </div>
        </div>
        <div class="row w-50">
          <div class="col">
            <base-input v-model="application.crossStreets"
                        label="Main Cross Streets"
                        placeholder="Main Cross Streets" disabled />
          </div>
        </div>
        <div class="row">
          <div class="col-8">
            <base-date-picker v-model="application.dateOfBurn"
                              label="Date of Burn" disabled />
          </div>
          <div class="col-4">
            <base-input v-model="application.totalHours"
                        label="Total Hours"
                        type="number"
                        max="24"
                        placeholder="Total Hours" disabled />
          </div>
        </div>
        <div class="row w-100">
          <div class="col-6">
            <base-input v-model="application.totalSessions"
                        label="How many burn sessions will be taking place?"
                        type="number"
                        placeholder="Total Sessions" disabled />
          </div>
        </div>
        <div class="row">
          <div class="col">
            <yes-no v-model="application.moreThanDay"
                    label="Is burn date over more than one day?" disabled />
          </div>
        </div>
        <div class="row w-100" v-if="application.moreThanDay == true">
          <div class="col">
            <base-textarea v-model="application.otherDate"
                           label="Detail other dates and hours:" disabled />
          </div>
        </div>
        <div class="row w-100">
          <div class="col">
            <base-input v-model="application.contactFirstName"
                        label="On Site Contact First Name"
                        placeholder="On Site Contact First Name" disabled />
          </div>
          <div class="col">
            <base-input v-model="application.contactLastName"
                        label="On Site Contact Last Name"
                        placeholder="On Site Contact Last Name" disabled />
          </div>
        </div>
        <div class="row w-100">
          <div class="col">
            <base-input v-model="application.contactPhone"
                        label="On Site Contact Phone"
                        type="tel"
                        mask="(###)-###-####"
                        placeholder="(xxx)-xxx-xxxx" disabled />
          </div>
        </div>
        <div class="row w-75">
          <div class="b-bottom w-100" v-for="(item, index) in application.burnMaterials">
            <div class="col">
              <base-input v-model="item.name"
                          label="Material Name"
                          placeholder="Material Name" disabled />
            </div>
            <div class="col">
              <base-input v-model="item.amount"
                          label="Material Amount"
                          placeholder="Material Amount" disabled />
            </div>
            <div class="col">
              <base-input v-model="item.description"
                          label="Material Description"
                          placeholder="Material Description" disabled />
            </div>
          </div>
        </div>
        <div class="row w-100">
          <div class="col">
            <base-textarea v-model="application.methodOfExtinguishment"
                           label="Method of extinguishment" disabled />
          </div>
        </div>
      </fieldset>
    </expanded-fieldset>
    <expanded-fieldset title="Signature">
      <fieldset>
        <legend> Signature </legend>
        <div class="row w-100">
          <div class="col-6">
            <base-input v-model="application.signature"
                        label="Signature"
                        placeholder="Signature" disabled />
          </div>
          <div class="col-6">
            <base-input v-model="application.signatureTitle"
                        label="Title of Signer"
                        placeholder="Title" disabled />
          </div>
        </div>
        <div class="row w-100">
          <div class="col">
            <base-date-picker v-model="application.signatureDate"
                              label="Date of Signature" disabled />
          </div>
        </div>
        <div class="row w-100">
          <div class="col-8">
            <base-textarea v-model="application.additionalComments"
                           label="Additional Comments" disabled />
          </div>
        </div>
      </fieldset>
    </expanded-fieldset>
    <div>
      <button type="button"
              class="btn btn-secondary"
              @click="cancel">
        Edit
      </button>
      <button v-if="hasFee" type="button"
              class="btn btn-primary"
              @click="checkout">
        Checkout
      </button>
      <button v-if="hasFee == false" type="button"
              class="btn btn-primary"
              @click="finalize">
        Submit
      </button>
    </div>
  </div>
</template>
<script>
import { PermitApplication, OpenBurnPermitApplication, OpenBurnFormData } from '@/js/FormObjects';
import { CapitalizeFilter } from '@/js/Mixins';
import cloneDeep from 'lodash/fp/cloneDeep';
import ExpandedFieldset from '@/components/ExplodedFieldset';
import BaseInput from '@/components/BaseInput';
import VAddress from '@/components/VAddress';
import BaseSelect from '@/components/BaseSelect';
import YesNo from '@/components/YesNo';
import BaseTimePicker from '@/components/BaseTimePicker';
import BaseDatePicker from '@/components/BaseDatePicker';
import BaseTextarea from '@/components/BaseTexarea';
import BaseCheckbox from '@/components/BaseCheckbox';
import BaseFileUploader from '@/components/BaseFileUploader';
import { getOpenBurnFeeStatus, submitOpenBurnNoFeeApplication } from '~/js/FormFunctions';

export default {
  name: 'OpenBurnReview',
  components: {
    ExpandedFieldset, BaseInput, VAddress, BaseSelect, YesNo, BaseTimePicker, BaseDatePicker, BaseTextarea, BaseCheckbox, BaseFileUploader,
  },
  mixins: [CapitalizeFilter],
  data() {
    return {
      application: new OpenBurnPermitApplication(),
      formFieldData: new OpenBurnFormData(),
      fetchingData: false,
      haseFee: false,
    };
  },
  mounted() {
    this.application = cloneDeep(this.$store.state.application);
    this.hasFee = this.$route.params.hasFee;
    // this.$store.commit('permitApplication', null)
    if (!(this.application)) {
      this.$notify('No permit application found.', 'error');
      this.$router.push({ name: 'OpenBurnLanding' });
    }
  },
  methods: {
    checkout() {
      const self = this;

      const formData = new FormData();
      Object.keys(this.application.files).forEach((key) => {
        if (self.application.files[key]) {
          formData.append(key, self.application.files[key]);
        }
      });

      // formData.append('form', JSON.stringify(this.application))
      this.$router.push({ name: 'OpenBurnCheckout', query: { permitId: this.application.permitNumber } });
      /*
      this.fetchingData = true
      self.$http.post(`/api/openburn/submit?applicationNumber=${this.application.applicationId}`)
        .then((response) => {
          self.fetchingData = false
          this.$router.push({name: 'OpenBurnCheckout', query: {permitId: response.data}})
        })
        .catch((error) => {
          console.error(error)
          self.fetchingData = false
          self.$notify('Error saving application record', 'error')
        })
        */
    },
    cancel() {
      this.$store.commit('temporaryForm', this.application);
      this.$router.push({
        name: 'OpenBurnApplication',
        params: {
          form: this.application,
        },
      });
    },
    finalize() {
      const self = this;
      this.fetchingData = true;
      submitOpenBurnNoFeeApplication(this.application.permitNumber)
        .then((result) => {
          self.$router.push({
            name: 'OpenBurnNoFeeThankYou',
            params: {
              applicationNumber: self.application.permitNumber,
            },
          });
        });
    },
  },
  computed: {

  },
};
</script>
